import { render, staticRenderFns } from "./Cuento.vue?vue&type=template&id=5d794901&"
import script from "./Cuento.vue?vue&type=script&lang=js&"
export * from "./Cuento.vue?vue&type=script&lang=js&"
import style0 from "./Cuento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports